import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=6d863256&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&id=6d863256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d863256",
  null
  
)

export default component.exports